import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarFilialApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/branch/createBranch`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarFilialApi = async (obj) => {
  try{
      const response = await axios.post(`${process.env.URL}/branch/getbranchs`, obj, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarFilialApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/branch/getBranchByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarCoordenadasFilialApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/branch/getCoordinates`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
     return false;
    }
  
}

export const atualizarFilialApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/branch/updateBranch`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirFilialApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/branch/deletebranch`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}